module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAUBAMAAABscEDKAAAAAXNSR0IB2cksfwAAACdQTFRFAAAAIHX/H3b/H3b/H3b/ADBQADVUADVVADVUADVUADRUH3b/ADVVJiBALAAAAA10Uk5TADDv//AQz2D/oEDg0Fs/rsEAAAB9SURBVHicY2AAA0YBBmQgpIjMY1Q2QpYWMjZWRJY0NkaSBkoiSYMkjY0dUSRNBNAkwwqQJVkz2lEkOzoKkCU7OtpRJEHSMGNngLhdDJuhdsaAuBMYRKB2sp7o6OgE6nWGOigGJMkAlIY4iPVEJ9heZ6hrYyaAKWmoa1mBGAAv0SajQTuSSgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/side-menu--icon--logo-dark.png
// module id = 935
// module chunks = 0